// @flow
import envConfig from "../../configs/envConfig";

export const zoomConstants = {
  sessionUser: "/sessionUser",
  getDashboardUrl: "/getUrl",
  logout: "/oauth/revoke/authToken",
  getCollectionsCashbook: "/operations/retail/collections/cashbook",
  getCollectionsSummary: "/operations/retail/collections/summary",
  getCollectionsHandover: "/operations/retail/collections/handover",
  makeEditPaymentCall: "/operations/retail/paymentTypeDetails",
  getBankDetails: "/master/bank?status=ACTIVE",
  getCnWiseHandoverDetails: "/operations/retail/collections/pending",
  getOverallOutstanding: "/operations/retail/ouOutstanding",
  initiateHandover: "/operations/retail/collections/initiatehandover",
  getOaScorecardData: "/oaScorecard",
  downloadDefectReport: "/oaScorecard/report",
  getCnoteDetails: "/operations/consignments/cnote/#cnote",
  ccGetUserClients: "/notification-user/search/user",
  ccGetDefaultUserSettings: "/notification-user/default",
  ccGetClientUserList: "/notification-user/search/name/clientId",
  ccEditNotificationsUser: "/notification-user/id",
  ccAddNotificationsUser: "/notification-user/",
  getTicketTypes: "/tickettype/keyval/#buId",
  getTicketTypeDetail: "/tickettype/detail",
  createTicketSubmit: "/ticket",
  editTicketSubmit: "/ticket/complete",
  getTicketDetails: "/ticket/detail",
  sendComments: "/comment",
  sendTicketEscalation: "/ticket/escalate",
  getTicketsHistory: "/ticket/history",
  getTicketsCount: "/ticket-lite/count",
  getAssignedTickets: "/ticket-lite/assigned",
  getUnassignedTickets: "/ticket-lite/unassigned",
  getCreatedTickets: "/ticket-lite/created",
  getAllTickets: "/ticket-lite/all",
  checkEWayBillValidity: "/e-waybill/ticket/#ticketId/check",
  getEntityInfo: "/ticket-entity/validate/#type/#id",
  getAssigneeOptions: "/usergroup/search",
  getUserInfoFromEmail: "/user/user-or-requestor/email",
  getUserInfoFromMobile: "/user/user-or-requestor/mobile",
  putEditTicketChanges: "/ticket",
  putAssignToMe: "/ticket/assigntome/ticketId",
  getClientCodeOptions: "/client/search/#pattern",
  getTicketsSearch: "/ticket-lite/search",
  getClusterLocationMapping: "/location/reportinglocations",
  getTicketStatusOptions: "/ticket/status",
  validateEWaybillNumber:
    "/e-waybill/#ewaybillNumber/validate/?cnote=#cnote&from-pincode=#from-pincode",
  consignmentQc: "/operations/consignments/qc",
  ticketingUserGroup: "/group/checkuser/",
  getCcedTickets: "/ticket-lite/cced",
  getBuTickets: "/ticket-lite/businessunit",
  getBuTypes: "/businessunit/all",
  getEscalatedTickets: "/ticket-lite/escalated",
  getGroupTypesByBu: "/grouptype/businessunit/#buId",
  getTicketTypesByBuAndGroupType: "/tickettype/grouptype/#id",
  ticketingGroup: "/location/all",
  getAllLocations: "/master/location",
  ticketingUsersByLocation: "/user/location",
  ticketingCategory: "/grouptype",
  ticketingIssue: "/tickettype",
  deleteIssue: "/tickettype/#id",
  ticketingResolverGroup: "/group/location-code-groups/#locationCode",
  ticketingResolverGroupCreate: "/group",
  ticketingBUSettings: "/user/updateaccess",
  bulkClose: "/ticket/bulkclose",
  bulkAssign: "/ticket/bulkassign",
  getTicketingUsers: "/user/search",
  getGroupSuggestion: "/auto-assign-suggestion/suggest",
  getTicketEntityTypes: "/ticket-entity/all",
  getTicketSearchOptions: "/ticket-lite/search-tags",
  qcmclosure: "/operations/consignments/qc/validateQcMeasurementClosure",
  qcmvalues: "/operations/consignments/qc/validateQcMeasurementValues",
  x: "/operations/consignments/qc/validateQcMeasurementValues",
  ticketaction: "/ticket-action",
  getPrimeClients: "/clients/getAllActiveClients"
};

const getUrlParams = replaceParamsArr => {
  // eg: replaceParamsArr = [{key:"abc", val:123}, {key:"abcd", val:1234} ]
  if (!replaceParamsArr || replaceParamsArr.length === 0) {
    return null;
  }
  let paramUrlString = "";
  let separator;
  const eqString = "=";
  replaceParamsArr.map(item => {
    separator = paramUrlString.indexOf("?") === -1 ? "?" : "&";
    paramUrlString =
      paramUrlString + separator + item.key + eqString + item.val;
    return item; // returning item just to avoid eslint error
  });
  return paramUrlString;
};

const getUrlWithPathVariables = (url, pathVariables) => {
  pathVariables.map(item => {
    url = url.replace(item.key, item.val);
    return item; // returning just for eslint
  });
  return url;
};

export const generateApiUrl = (apiCallObj: Object) => {
  let url =
    envConfig[apiCallObj.baseUrl] + zoomConstants[apiCallObj.apiEndPoint];
  if (apiCallObj.replaceParamsArr) {
    url += getUrlParams(apiCallObj.replaceParamsArr);
  }
  if (apiCallObj.pathVariables) {
    url = getUrlWithPathVariables(url, apiCallObj.pathVariables);
  }
  return url;
};



// WEBPACK FOOTER //
// ./app/services/apiService/apiEndPoints.js